import { adjuntoBuilder } from '../components/reutilizables/upload/adjuntoBuilder.js'
import * as imagenesService from '../components/servicios/imagenesService.js'
import sinfoto from '../img/sinfoto.jpg'

export const obtenerImagenesPublicacion = async ({
  idPublicaciones,
  idPublicacionTemporal,
  idUsuario,
  setAdjuntos,
  tieneFotoDefault = true,
  soloImagenPrincipal = true
}) => {
  const { data } = await imagenesService.buscarImagenes({
    idPublicaciones,
    idPublicacionTemporal,
    registroAddUsr: idUsuario,
    soloImagenPrincipal
  })
  const body = data.body || {}
  let archivos

  if (Array.isArray(body.temporal)) {
    archivos = body.temporal
  } else {
    archivos = Object.entries(body).flatMap(([idPublicacion, items]) => {
      return { ...items, idPublicacion: Number(idPublicacion) }
    })
  }

  if (archivos.length > 0) {
    const adjuntosConstruidos = await Promise.allSettled(
      archivos.map(async (archivoData) => {
        try {
          const archivo = await imagenesService.obtenerImagen(archivoData)
          const adjunto = await adjuntoBuilder(archivo.data, archivoData, archivoData.nombre, {
            isBase64: false,
            preview: true
          })

          return { ...adjunto, idPublicacion: archivoData.idPublicacion }
        } catch {
          return {
            idAdjunto: archivoData.idAdjunto,
            url: sinfoto,
            nombre: 'Sin foto',
            idPublicacion: archivoData.idPublicacion
          }
        }
      })
    )

    setAdjuntos(adjuntosConstruidos.map((a) => a.value))
  } else if (tieneFotoDefault) {
    setAdjuntos((prev) => [...prev, { url: sinfoto, nombre: 'Sin foto', idPublicacion: null }])
  }
}
